export const useLocalizedSlug = () => {
  const { locale } = useI18n()

  /**
   * Get the localized slug based on the current locale
   * @param {Object|string|null} slug - The slug configuration
   * @returns {string|null} The localized slug
   */
  const getLocalizedSlug = (slug) => {
    if (!slug) return null

    // If slug is an object with locale keys, return the appropriate one
    if (typeof slug === 'object' && !Array.isArray(slug)) {
      // Use current locale or fallback to Danish
      return slug[locale.value] || slug.da || Object.values(slug)[0]
    }

    // If slug is a string (backward compatibility)
    return slug
  }

  return {
    getLocalizedSlug
  }
}
